import FormModule from "components/Modules/Documents/FormModule"
import {
  createOrUpdateFirestoreDocument,
  getFirestoreDocument,
} from "helpers/Firestore"
import {
  normalizeWidgetData,
  prepareWidgetDataForSave,
} from "../budgetWidgetData"

const CityBudgetSettings = () => {
  return (
    <FormModule
      noCancel
      form={{
        title: "Settings",
        fields: [
          {
            ID: "budget-earnings-title",
            Name: "WidgetData.data.1.title",
            Label: "Earnings title",
            Type: "Text",
          },
          {
            ID: "budget-expenses-title",
            Name: "WidgetData.data.2.title",
            Label: "Expenses title",
            Type: "Text",
          },
          {
            ID: "budget-row-1-subtitle",
            Name: "WidgetData.dataList.widget.row_1.subtitle",
            Label: "Widget - Row 1 title",
            Type: "Text",
          },
          {
            ID: "budget-row-1-value",
            Name: "WidgetData.dataList.widget.row_1.value",
            Label: "Widget - Row 1 value",
            Type: "Text",
          },
          {
            ID: "budget-row-2-subtitle",
            Name: "WidgetData.dataList.widget.row_2.subtitle",
            Label: "Widget - Row 2 title",
            Type: "Text",
          },
          {
            ID: "budget-row-2-value",
            Name: "WidgetData.dataList.widget.row_2.value",
            Label: "Widget - Row 2 value",
            Type: "Text",
          },
        ],
        getDefaultValues: async ({ firebaseUID }) => {
          const moduleDoc = await getFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules/136`,
          })

          return {
            WidgetData: normalizeWidgetData(moduleDoc?.WidgetData || {}),
          }
        },
        onSubmit: async (values, { firebaseUID }) => {
          const widgetData = prepareWidgetDataForSave(values.WidgetData || {})

          await createOrUpdateFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules`,
            values: {
              ID: "136",
              WidgetData: widgetData,
            },
          })

          return values
        },
      }}
      ID={"136"}
    />
  )
}

export default CityBudgetSettings
